module.exports = __webpack_public_path__ + "media/Video 96b.787700b5.mp4";